import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ModeloChipInterface } from 'app/module/modelo-chip-interface';

@Injectable({
	providedIn: 'root'
})
export class ModeloChipService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<ModeloChipInterface[]> {
		return this.http.get<ModeloChipInterface[]>(`${this.url}modelo-chip`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
